import type { ITrackerConfig } from "@litres-libs/tracker-manager";
import TrackerManager from "@litres-libs/tracker-manager";
import { hasWindow } from "@litres/utils";

export const TM = TrackerManager.getInstance();

export const trackerStart = (config: ITrackerConfig) => {
  if (hasWindow) {
    TM.setConfiguration(config);
  }
};

export const trackerSendHeaderClick = (name: string, ref_url: string) => {
  TM.sendEvent(["LITRES_TRACKER"], {
    eventType: "header_click",
    params: {
      name,
      ref_url,
    },
  });
};
